import React from 'react';

import {
  Box,
  Icon,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { Clock, Lightning } from '@phosphor-icons/react';
import { capitalize } from 'lodash';

import { timeOptions } from 'components/account_v2/helpers/signalsNotificationFormHelpers';
import { NotificationPolicyPriority } from 'queries/notificationPolicy';

import { PolicyComplianceIndicator } from './PolicyComplianceIndicator';

interface PolicyRequirementsProps {
  policyPriority: NotificationPolicyPriority;
  complianceStatus?: Array<{
    stepIndex: number;
    isCompliant: boolean;
  }>;
}

const getDelayLabel = (delay: string) => {
  const option = timeOptions.find((opt) => opt.value === delay);
  return option?.label || delay;
};

export const PolicyRequirements = ({
  policyPriority,
  complianceStatus = [],
}: PolicyRequirementsProps) => {
  return (
    <Box>
      <Text textStyle="heading3" mb="3">
        {capitalize(policyPriority.priority)} Priority Requirements
      </Text>

      <TableContainer>
        <Table size="sm" variant="simple">
          <Thead>
            <Tr>
              <Th>Policy</Th>
              <Th>In Compliance</Th>
            </Tr>
          </Thead>
          <Tbody>
            {policyPriority.steps.map((step, index) => {
              const compliance = complianceStatus.find(
                (c) => c.stepIndex === index,
              );
              const isCompliant = compliance?.isCompliant ?? false;

              return (
                <Tr key={index}>
                  <Td>
                    <Text textStyle="body2" mb="2" color="content.secondary">
                      {step.notification_type?.label || 'No notification type'}
                    </Text>
                    <Tag variant="roundedOutline" size="sm" gap="1">
                      {step.delay === 'PT0S' ? (
                        <Icon as={Lightning} />
                      ) : (
                        <Icon as={Clock} />
                      )}

                      {step.delay === 'PT0S'
                        ? getDelayLabel(step.delay)
                        : `Within ${getDelayLabel(step.delay)}`}
                    </Tag>
                  </Td>
                  <Td>
                    <PolicyComplianceIndicator
                      isCompliant={isCompliant}
                      size="sm"
                      showLabel={false}
                      userId=""
                    />
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
